/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
/* import Menu from './Menu.js'; */
import HomeButton from './HomeButton.js';
import Top from './Top.js';
import Step1 from './Step1.js';
import Step2 from './Step2.js';
import Step3 from './Step3.js';
import Step4 from './Step4.js';
import Result from './Result.js';
import Thankyou from './Thankyou.js';

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        office_people: 300,
        office_area: 3000,
        office_rent: 2000,
        office_remotefeeP: 1.0,
        office_teatejukyu: 50,

        //ギャザリング比率
        kako_gath: 0.1,
        now_gath: 0.1,
        new_gath: 0.1,
        future_gath: 0.4,

        //フリーアドレス係数
        free_keisu: 0.5,

        kako_free: 50,
        kako_kotei: 50,
        kako_shusha: 100,
        kako_remote: 0,
        kako_area: '',
        kako_gatharea: '',
        kako_otherarea: '',
        kako_koteiarea: '',
        kako_freearea: '',
        kako_koteiareaP: '',
        kako_freeareaP: '',
        kako_officefee: '',
        kako_officerent: '',
        kako_remotefee: '',
        kako_officefeeP: '',
        kako_remotefeeP: '',
        kako_teatejukyu: '',
        kako_teatetotal: '',

        now_free: 0,
        now_kotei: 100,
        now_shusha: 20,
        now_remote: 80,
        now_area: '',
        now_gatharea: '',
        now_otherarea: '',
        now_koteiarea: '',
        now_freearea: '',
        now_officefee: '',
        now_officerent: '',
        now_remotefee: '',
        now_officefeeP: '',
        now_remotefeeP: '',
        now_teatejukyu: '',
        now_teatetotal: '',
        now_area_zogen: '',
        now_officefee_zogen: '',
        now_officefeeP_zogen: '',

        new_free: 25,
        new_kotei: 75,
        new_shusha: 50,
        new_remote: 50,
        new_area: '',
        new_gatharea: '',
        new_otherarea: '',
        new_koteiarea: '',
        new_freearea: '',
        new_officefee: '',
        new_officerent: '',
        new_remotefee: '',
        new_officefeeP: '',
        new_remotefeeP: '',
        new_teatejukyu: '',
        new_teatetotal: '',
        new_area_zogen: '',
        new_officefee_zogen: '',
        new_officefeeP_zogen: '',

        future_free: 90,
        future_kotei: 10,
        future_shusha: 30,
        future_remote: 70,
        future_area: '',
        future_gatharea: '',
        future_otherarea: '',
        future_koteiarea: '',
        future_freearea: '',
        future_officefee: '',
        future_officerent: '',
        future_remotefee: '',
        future_officefeeP: '',
        future_remotefeeP: '',
        future_teatejukyu: '',
        future_teatetotal: '',
        future_area_zogen: '',
        future_officefee_zogen: '',
        future_officefeeP_zogen: '',
      },
    };
  }

  valueCheck(value) {
    //数字のみ
    const re = /^[0-9\b]+$/;
    if (value === '' || re.test(value)) {
      return true;
    } else {
      return false;
    }
  }

  hankaku2Zenkaku(str) {
    str = str.replace(/。/g, '．');
    str = str.replace(/、/g, '．');
    return str.replace(/[！-～]/g, function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    });
  }

  handleKakoShushaChange(value) {
    value = this.hankaku2Zenkaku(value);
    if (this.valueCheck(value)) {
      if (0 > value || value > 100) return;
      const tmp = this.state.data;
      tmp.kako_shusha = Math.round(value);
      tmp.kako_remote = 100 - Math.round(value);
      this.setState({ data: tmp });
      localStorage.setItem('kako_shusha', tmp.kako_shusha);
      localStorage.setItem('kako_remote', tmp.kako_remote);
    }
  }

  handleKakoRemoteChange(value) {
    value = this.hankaku2Zenkaku(value);
    if (this.valueCheck(value)) {
      if (0 > value || value > 100) return;
      const tmp = this.state.data;
      tmp.kako_remote = Math.round(value);
      tmp.kako_shusha = 100 - Math.round(value);
      this.setState({ data: tmp });
      localStorage.setItem('kako_shusha', tmp.kako_shusha);
      localStorage.setItem('kako_remote', tmp.kako_remote);
    }
  }

  handleKakoFreeChange(value) {
    value = this.hankaku2Zenkaku(value);
    if (this.valueCheck(value)) {
      if (0 > value || value > 100) return;
      const tmp = this.state.data;
      tmp.kako_free = Math.round(value);
      tmp.kako_kotei = 100 - Math.round(value);
      this.setState({ data: tmp });
      localStorage.setItem('kako_free', tmp.kako_free);
      localStorage.setItem('kako_kotei', tmp.kako_kotei);
    }
  }

  handleKakoKoteiChange(value) {
    value = this.hankaku2Zenkaku(value);
    if (this.valueCheck(value)) {
      if (0 > value || value > 100) return;
      const tmp = this.state.data;
      tmp.kako_kotei = Math.round(value);
      tmp.kako_free = 100 - Math.round(value);
      this.setState({ data: tmp });
      localStorage.setItem('kako_free', tmp.kako_free);
      localStorage.setItem('kako_kotei', tmp.kako_kotei);
    }
  }

  handleNowShushaChange(value) {
    value = this.hankaku2Zenkaku(value);
    if (this.valueCheck(value)) {
      if (0 > value || value > 100) return;
      const tmp = this.state.data;
      tmp.now_shusha = Math.round(value);
      tmp.now_remote = 100 - Math.round(value);
      this.setState({ data: tmp });
      localStorage.setItem('now_shusha', tmp.now_shusha);
      localStorage.setItem('now_remote', tmp.now_remote);
    }
  }

  handleNowRemoteChange(value) {
    value = this.hankaku2Zenkaku(value);
    if (this.valueCheck(value)) {
      if (0 > value || value > 100) return;
      const tmp = this.state.data;
      tmp.now_remote = Math.round(value);
      tmp.now_shusha = 100 - Math.round(value);
      this.setState({ data: tmp });
      localStorage.setItem('now_shusha', tmp.now_shusha);
      localStorage.setItem('now_remote', tmp.now_remote);
    }
  }

  handleNowFreeChange(value) {
    value = this.hankaku2Zenkaku(value);
    if (this.valueCheck(value)) {
      if (0 > value || value > 100) return;
      const tmp = this.state.data;
      tmp.now_free = Math.round(value);
      tmp.now_kotei = 100 - Math.round(value);
      this.setState({ data: tmp });
      localStorage.setItem('now_free', tmp.now_free);
      localStorage.setItem('now_kotei', tmp.now_kotei);
    }
  }

  handleNowKoteiChange(value) {
    value = this.hankaku2Zenkaku(value);
    if (this.valueCheck(value)) {
      if (0 > value || value > 100) return;
      const tmp = this.state.data;
      tmp.now_kotei = Math.round(value);
      tmp.now_free = 100 - Math.round(value);
      this.setState({ data: tmp });
      localStorage.setItem('now_free', tmp.now_free);
      localStorage.setItem('now_kotei', tmp.now_kotei);
    }
  }

  handleNewShushaChange(value) {
    value = this.hankaku2Zenkaku(value);
    if (this.valueCheck(value)) {
      if (0 > value || value > 100) return;
      const tmp = this.state.data;
      tmp.new_shusha = Math.round(value);
      tmp.new_remote = 100 - Math.round(value);
      this.setState({ data: tmp });
      localStorage.setItem('new_shusha', tmp.new_shusha);
      localStorage.setItem('new_remote', tmp.new_remote);
    }
  }

  handleNewRemoteChange(value) {
    value = this.hankaku2Zenkaku(value);
    if (this.valueCheck(value)) {
      if (0 > value || value > 100) return;
      const tmp = this.state.data;
      tmp.new_remote = Math.round(value);
      tmp.new_shusha = 100 - Math.round(value);
      this.setState({ data: tmp });
      localStorage.setItem('new_shusha', tmp.new_shusha);
      localStorage.setItem('new_remote', tmp.new_remote);
    }
  }

  handleNewFreeChange(value) {
    value = this.hankaku2Zenkaku(value);
    if (this.valueCheck(value)) {
      if (0 > value || value > 100) return;
      const tmp = this.state.data;
      tmp.new_free = Math.round(value);
      tmp.new_kotei = 100 - Math.round(value);
      this.setState({ data: tmp });
      localStorage.setItem('new_free ', tmp.new_free);
      localStorage.setItem('new_kotei', tmp.new_kotei);
    }
  }

  handleNewKoteiChange(value) {
    value = this.hankaku2Zenkaku(value);
    if (this.valueCheck(value)) {
      if (0 > value || value > 100) return;
      const tmp = this.state.data;
      tmp.new_kotei = Math.round(value);
      tmp.new_free = 100 - Math.round(value);
      this.setState({ data: tmp });
      localStorage.setItem('new_free ', tmp.new_free);
      localStorage.setItem('new_kotei', tmp.new_kotei);
    }
  }

  handleOfficePeopleChange(value) {
    value = this.hankaku2Zenkaku(value);
    if (this.valueCheck(value)) {
      const tmp = this.state.data;
      tmp.office_people = value;
      this.setState({ data: tmp });
      localStorage.setItem('office_people', tmp.office_people);
    }
  }

  handleOfficeAreaChange(value) {
    value = this.hankaku2Zenkaku(value);
    if (this.valueCheck(value)) {
      const tmp = this.state.data;
      tmp.office_area = value;
      this.setState({ data: tmp });
      localStorage.setItem('office_area', tmp.office_area);
    }
  }

  handleOfficeRentChange(value) {
    value = this.hankaku2Zenkaku(value);
    if (this.valueCheck(value)) {
      const tmp = this.state.data;
      tmp.office_rent = value;
      this.setState({ data: tmp });
      localStorage.setItem('office_rent', tmp.office_rent);
    }
  }

  handleOfficeRemoteFeePChange(value) {
    value = this.hankaku2Zenkaku(value);
    const re = /^\d*\.?\d*$/;
    if (value === '' || re.test(value)) {
      const tmp = this.state.data;
      if (typeof value != 'string') {
        value = value.toFixed(1);
      }
      tmp.office_remotefeeP = value;
      this.setState({ data: tmp });
      localStorage.setItem('office_remotefeeP', tmp.office_remotefeeP);
    }
  }

  handleNowRemoteFeePChange(value) {
    value = this.hankaku2Zenkaku(value);
    const re = /^\d*\.?\d*$/;
    if (value === '' || re.test(value)) {
      const tmp = this.state.data;
      if (typeof value != 'string') {
        value = value.toFixed(1);
      }
      tmp.now_remotefeeP = value;
      this.setState({ data: tmp });
      localStorage.setItem('now_remotefeeP', tmp.now_remotefeeP);
    }
  }

  handleNewRemoteFeePChange(value) {
    value = this.hankaku2Zenkaku(value);
    const re = /^\d*\.?\d*$/;
    if (value === '' || re.test(value)) {
      const tmp = this.state.data;
      if (typeof value != 'string') {
        value = value.toFixed(1);
      }
      tmp.new_remotefeeP = value;
      this.setState({ data: tmp });
      localStorage.setItem('new_remotefeeP', tmp.new_remotefeeP);
    }
  }

  handleOfficeTeateJukyuChange(value) {
    value = this.hankaku2Zenkaku(value);
    if (this.valueCheck(value)) {
      if (0 > value || value > 100) return;
      const tmp = this.state.data;
      tmp.office_teatejukyu = value;
      this.setState({ data: tmp });
      localStorage.setItem('office_teatejukyu', tmp.office_teatejukyu);
    }
  }

  handleNowTeateJukyuChange(value) {
    value = this.hankaku2Zenkaku(value);
    if (this.valueCheck(value)) {
      if (0 > value || value > 100) return;
      const tmp = this.state.data;
      tmp.now_teatejukyu = value;
      this.setState({ data: tmp });
      localStorage.setItem('now_teatejukyu', tmp.now_teatejukyu);
    }
  }

  handleNewTeateJukyuChange(value) {
    value = this.hankaku2Zenkaku(value);
    if (this.valueCheck(value)) {
      if (0 > value || value > 100) return;
      const tmp = this.state.data;
      tmp.new_teatejukyu = value;
      this.setState({ data: tmp });
      localStorage.setItem('new_teatejukyu', tmp.new_teatejukyu);
    }
  }

  setLocalStrage() {
    localStorage.setItem('kako_shusha', this.state.data.kako_shusha);
    localStorage.setItem('kako_remote', this.state.data.kako_remote);
    localStorage.setItem('kako_free', this.state.data.kako_free);
    localStorage.setItem('kako_kotei', this.state.data.kako_kotei);
    localStorage.setItem('now_shusha', this.state.data.now_shusha);
    localStorage.setItem('now_remote', this.state.data.now_remote);
    localStorage.setItem('now_free', this.state.data.now_free);
    localStorage.setItem('now_kotei', this.state.data.now_kotei);
    localStorage.setItem('new_shusha', this.state.data.new_shusha);
    localStorage.setItem('new_remote', this.state.data.new_remote);
    localStorage.setItem('new_free ', this.state.data.new_free);
    localStorage.setItem('new_kotei', this.state.data.new_kotei);
    localStorage.setItem('office_people', this.state.data.office_people);
    localStorage.setItem('office_area', this.state.data.office_area);
    localStorage.setItem('office_rent', this.state.data.office_rent);
    localStorage.setItem('office_remotefeeP', this.state.data.office_remotefeeP);
    localStorage.setItem('now_remotefeeP', this.state.data.now_remotefeeP);
    localStorage.setItem('new_remotefeeP', this.state.data.new_remotefeeP);
    localStorage.setItem('future_remotefeeP', this.state.data.future_remotefeeP);
    localStorage.setItem('office_teatejukyu', this.state.data.office_teatejukyu);
    localStorage.setItem('now_teatejukyu', this.state.data.now_teatejukyu);
    localStorage.setItem('new_teatejukyu', this.state.data.new_teatejukyu);
    localStorage.setItem('future_teatejukyu', this.state.data.future_teatejukyu);
  }

  getLocalStrage() {
    const tmp = this.state.data;
    tmp.kako_shusha = Number(localStorage.getItem('kako_shusha'));
    tmp.kako_remote = Number(localStorage.getItem('kako_remote'));
    tmp.kako_free = Number(localStorage.getItem('kako_free'));
    tmp.kako_kotei = Number(localStorage.getItem('kako_kotei'));
    tmp.now_shusha = Number(localStorage.getItem('now_shusha'));
    tmp.now_remote = Number(localStorage.getItem('now_remote'));
    tmp.now_free = Number(localStorage.getItem('now_free'));
    tmp.now_kotei = Number(localStorage.getItem('now_kotei'));
    tmp.new_shusha = Number(localStorage.getItem('new_shusha'));
    tmp.new_remote = Number(localStorage.getItem('new_remote'));
    tmp.new_free = Number(localStorage.getItem('new_free'));
    tmp.new_kotei = Number(localStorage.getItem('new_kotei'));
    tmp.office_people = Number(localStorage.getItem('office_people'));
    tmp.office_area = Number(localStorage.getItem('office_area'));
    tmp.office_rent = Number(localStorage.getItem('office_rent'));
    tmp.office_remotefeeP = localStorage.getItem('office_remotefeeP');
    tmp.now_remotefeeP = localStorage.getItem('now_remotefeeP');
    tmp.new_remotefeeP = localStorage.getItem('new_remotefeeP');
    tmp.future_remotefeeP = localStorage.getItem('future_remotefeeP');
    tmp.office_teatejukyu = Number(localStorage.getItem('office_teatejukyu'));
    tmp.now_teatejukyu = Number(localStorage.getItem('now_teatejukyu'));
    tmp.new_teatejukyu = Number(localStorage.getItem('new_teatejukyu'));
    tmp.new_teatejukyu = Number(localStorage.getItem('new_teatejukyu'));
    tmp.future_teatejukyu = Number(localStorage.getItem('future_teatejukyu'));
    this.setState({ data: tmp });
  }

  setTeate() {
    const tmp = this.state.data;
    if (typeof tmp.office_remotefeeP != 'string') {
      tmp.office_remotefeeP = tmp.office_remotefeeP.toFixed(1);
    }
    tmp.now_remotefeeP = tmp.office_remotefeeP;
    tmp.new_remotefeeP = tmp.office_remotefeeP;
    tmp.future_remotefeeP = tmp.office_remotefeeP;
    tmp.now_teatejukyu = tmp.office_teatejukyu;
    tmp.new_teatejukyu = tmp.office_teatejukyu;
    tmp.future_teatejukyu = tmp.office_teatejukyu;
    this.setState({ data: tmp });
  }

  calc() {
    const tmp = this.state.data;

    //過去
    //オフィス面積
    tmp.kako_area = this.state.data.office_area;
    //ギャザリングスペース
    tmp.kako_gatharea = tmp.kako_area * tmp.kako_gath;
    //その他スペース
    tmp.kako_otherarea = tmp.kako_area * (1 - tmp.kako_gath);
    //1人当たり固定席面積
    tmp.kako_koteiareaP =
      tmp.kako_otherarea /
      tmp.office_people /
      (tmp.kako_kotei / 100 -
        (tmp.kako_kotei / 100) * tmp.free_keisu * (tmp.kako_shusha / 100) +
        tmp.free_keisu * (tmp.kako_shusha / 100));
    //固定席面積
    tmp.kako_koteiarea = tmp.kako_koteiareaP * tmp.office_people * tmp.kako_koteiarea;
    //1人当たりフリーアドレス面積
    tmp.kako_freeareaP = tmp.kako_koteiareaP * tmp.free_keisu;
    //フリーアドレス面積
    tmp.kako_freearea = tmp.kako_freeareaP * tmp.office_people * (tmp.kako_free / 100) * (tmp.kako_shusha / 100);
    //出社1人あたりオフィス面積
    tmp.kako_shushaareaP = tmp.kako_area / (tmp.office_people * (tmp.kako_shusha / 100));
    //オフィス賃料
    tmp.kako_officerent = tmp.office_rent;
    //一人当たりテレワーク手当
    tmp.kako_remotefeeP = tmp.office_remotefeeP;
    //手当受給率
    tmp.kako_teatejukyu = tmp.office_teatejukyu;
    //手当総額
    tmp.kako_teatetotal = Math.round(tmp.kako_remotefeeP * tmp.office_people * (tmp.kako_teatejukyu / 100) * 10) / 10;
    //テレワーク費用
    tmp.kako_remotefee = tmp.office_people * tmp.kako_remotefeeP * (tmp.kako_teatejukyu / 100);
    //オフィス費用
    tmp.kako_officefee = Math.round(Number(tmp.kako_officerent) + Number(tmp.kako_remotefee));
    //一人当たりオフィス費用
    tmp.kako_officefeeP = Math.round((tmp.kako_officefee / tmp.office_people) * 10) / 10;

    //現在
    tmp.now_gatharea = tmp.kako_area * tmp.now_gath * (tmp.now_shusha / tmp.kako_shusha);
    tmp.now_koteiarea = tmp.kako_koteiareaP * tmp.office_people * (tmp.now_kotei / 100);
    tmp.now_free = 100 - tmp.now_kotei;
    tmp.now_freearea = tmp.kako_freeareaP * tmp.office_people * (tmp.now_free / 100) * (tmp.now_shusha / 100);
    tmp.now_otherarea = tmp.now_koteiarea + tmp.now_freearea;
    tmp.now_area = Math.round(tmp.now_gatharea + tmp.now_otherarea);
    tmp.now_officerent = (tmp.kako_officerent / tmp.kako_area) * tmp.now_area;
    tmp.now_remotefee = tmp.office_people * tmp.now_remotefeeP * (tmp.now_teatejukyu / 100);
    tmp.now_officefee = Math.round(tmp.now_officerent + tmp.now_remotefee);
    tmp.now_officefeeP = Math.round((tmp.now_officefee / tmp.office_people) * 10) / 10;
    tmp.now_teatetotal = Math.round(tmp.now_remotefeeP * tmp.office_people * (tmp.now_teatejukyu / 100) * 10) / 10;
    tmp.now_area_zogen = Math.round(((tmp.now_area - tmp.kako_area) / tmp.kako_area) * 100);
    tmp.now_officefee_zogen = Math.round(((tmp.now_officefee - tmp.kako_officefee) / tmp.kako_officefee) * 100);
    tmp.now_officefeeP_zogen = Math.round(((tmp.now_officefeeP - tmp.kako_officefeeP) / tmp.kako_officefeeP) * 100);

    //今後
    tmp.new_gatharea = tmp.kako_area * tmp.new_gath * (tmp.new_shusha / tmp.kako_shusha);
    tmp.new_koteiarea = tmp.kako_koteiareaP * tmp.office_people * (tmp.new_kotei / 100);
    tmp.new_free = 100 - tmp.new_kotei;
    tmp.new_freearea = tmp.kako_freeareaP * tmp.office_people * (tmp.new_free / 100) * (tmp.new_shusha / 100);
    tmp.new_otherarea = tmp.new_koteiarea + tmp.new_freearea;
    tmp.new_area = Math.round(tmp.new_gatharea + tmp.new_otherarea);
    tmp.new_officerent = (tmp.kako_officerent / tmp.kako_area) * tmp.new_area;
    tmp.new_remotefee = tmp.office_people * tmp.new_remotefeeP * (tmp.new_teatejukyu / 100);
    tmp.new_officefee = Math.round(tmp.new_officerent + tmp.new_remotefee);
    tmp.new_officefeeP = Math.round((tmp.new_officefee / tmp.office_people) * 10) / 10;
    tmp.new_teatetotal = Math.round(tmp.new_remotefeeP * tmp.office_people * (tmp.new_teatejukyu / 100) * 10) / 10;
    tmp.new_area_zogen = Math.round(((tmp.new_area - tmp.kako_area) / tmp.kako_area) * 100);
    tmp.new_officefee_zogen = Math.round(((tmp.new_officefee - tmp.kako_officefee) / tmp.kako_officefee) * 100);
    tmp.new_officefeeP_zogen = Math.round(((tmp.new_officefeeP - tmp.kako_officefeeP) / tmp.kako_officefeeP) * 100);

    //codetta
    tmp.future_gatharea = tmp.kako_area * tmp.future_gath * (tmp.future_shusha / tmp.kako_shusha);
    tmp.future_koteiarea = tmp.kako_koteiareaP * tmp.office_people * (tmp.future_kotei / 100);
    tmp.future_freearea = tmp.kako_freeareaP * tmp.office_people * (tmp.future_free / 100) * (tmp.future_shusha / 100);
    tmp.future_otherarea = tmp.future_koteiarea + tmp.future_freearea;
    tmp.future_area = Math.round(tmp.future_gatharea + tmp.future_otherarea);
    tmp.future_officerent = (tmp.kako_officerent / tmp.kako_area) * tmp.future_area;
    tmp.future_remotefee = tmp.office_people * tmp.future_remotefeeP * (tmp.future_teatejukyu / 100);
    tmp.future_officefee = Math.round(tmp.future_officerent + tmp.future_remotefee);
    tmp.future_officefeeP = Math.round((tmp.future_officefee / tmp.office_people) * 10) / 10;
    tmp.future_teatetotal =
      Math.round(tmp.future_remotefeeP * tmp.office_people * (tmp.future_teatejukyu / 100) * 10) / 10;
    tmp.future_area_zogen = Math.round(((tmp.future_area - tmp.kako_area) / tmp.kako_area) * 100);
    tmp.future_officefee_zogen = Math.round(((tmp.future_officefee - tmp.kako_officefee) / tmp.kako_officefee) * 100);
    tmp.future_officefeeP_zogen = Math.round(
      ((tmp.future_officefeeP - tmp.kako_officefeeP) / tmp.kako_officefeeP) * 100
    );
    this.setState({ data: tmp });

    this.setLocalStrage();
  }

  render() {
    return (
      <div className="body">
        <BrowserRouter>
          {/*<Menu />*/}
          <HomeButton />
          <AnimatePresence>
            <Switch>
              <Route exact path="/" component={Top} />
              <Route
                exact
                path="/step1"
                render={() => (
                  <Step1
                    handleOfficePeopleChange={(e) => this.handleOfficePeopleChange(e)}
                    handleOfficeAreaChange={(e) => this.handleOfficeAreaChange(e)}
                    handleOfficeRentChange={(e) => this.handleOfficeRentChange(e)}
                    data={this.state.data}
                  />
                )}
              />
              <Route
                exact
                path="/step2"
                render={() => (
                  <Step2
                    handleKakoFreeChange={(e) => this.handleKakoFreeChange(e)}
                    handleKakoKoteiChange={(e) => this.handleKakoKoteiChange(e)}
                    handleNowFreeChange={(e) => this.handleNowFreeChange(e)}
                    handleNowKoteiChange={(e) => this.handleNowKoteiChange(e)}
                    handleNewFreeChange={(e) => this.handleNewFreeChange(e)}
                    handleNewKoteiChange={(e) => this.handleNewKoteiChange(e)}
                    data={this.state.data}
                  />
                )}
              />
              <Route
                exact
                path="/step3"
                render={() => (
                  <Step3
                    handleKakoShushaChange={(e) => this.handleKakoShushaChange(e)}
                    handleKakoRemoteChange={(e) => this.handleKakoRemoteChange(e)}
                    handleNowShushaChange={(e) => this.handleNowShushaChange(e)}
                    handleNowRemoteChange={(e) => this.handleNowRemoteChange(e)}
                    handleNewShushaChange={(e) => this.handleNewShushaChange(e)}
                    handleNewRemoteChange={(e) => this.handleNewRemoteChange(e)}
                    data={this.state.data}
                  />
                )}
              />
              <Route
                exact
                path="/step4"
                render={() => (
                  <Step4
                    handleOfficeRemoteFeePChange={(e) => this.handleOfficeRemoteFeePChange(e)}
                    handleOfficeTeateJukyuChange={(e) => this.handleOfficeTeateJukyuChange(e)}
                    setTeate={() => this.setTeate()}
                    calc={() => this.calc()}
                    data={this.state.data}
                  />
                )}
              />
              <Route
                exact
                path="/result"
                render={() => (
                  <Result
                    data={this.state.data}
                    handleNowFreeChange={(e) => this.handleNowFreeChange(e)}
                    handleNowKoteiChange={(e) => this.handleNowKoteiChange(e)}
                    handleNewFreeChange={(e) => this.handleNewFreeChange(e)}
                    handleNewKoteiChange={(e) => this.handleNewKoteiChange(e)}
                    handleNowShushaChange={(e) => this.handleNowShushaChange(e)}
                    handleNowRemoteChange={(e) => this.handleNowRemoteChange(e)}
                    handleNewShushaChange={(e) => this.handleNewShushaChange(e)}
                    handleNewRemoteChange={(e) => this.handleNewRemoteChange(e)}
                    handleOfficePeopleChange={(e) => this.handleOfficePeopleChange(e)}
                    handleOfficeAreaChange={(e) => this.handleOfficeAreaChange(e)}
                    handleOfficeRentChange={(e) => this.handleOfficeRentChange(e)}
                    handleNowRemoteFeePChange={(e) => this.handleNowRemoteFeePChange(e)}
                    handleNewRemoteFeePChange={(e) => this.handleNewRemoteFeePChange(e)}
                    handleNowTeateJukyuChange={(e) => this.handleNowTeateJukyuChange(e)}
                    handleNewTeateJukyuChange={(e) => this.handleNewTeateJukyuChange(e)}
                    calc={() => this.calc()}
                    getLocalStrage={() => this.getLocalStrage()}
                    handleKakoShushaChange={this.handleKakoShushaChange}
                  />
                )}
              />
              <Route exact path="/thankyou" component={Thankyou} />
            </Switch>
          </AnimatePresence>
        </BrowserRouter>{' '}
      </div>
    );
  }
}

export default Main;
